import React, { useRef, useEffect, createRef, useState, useCallback } from 'react'
import { XDivider, YDivider, FlexByRowCentered } from '../../../irmlib/src/styles'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import { useFormPageHandler, useMergeState } from 'irmlib/hooks'
import { OutlinedButton, Label, ContainedButton, ThemeButton } from 'irmlib/components/Controls'
import { CancelButton, TextField, SaveButton, Select, TextFieldBorderless } from 'irmlib/components/FormControls'
import { openGeneralDialog, closeGeneralDialog, setBusy, clearBusy } from 'irmlib/containers'
import SummaryHeader from '../../Controls/SummaryHeader'
import { useLocation, useHistory } from 'react-router-dom'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import * as gdeTransactionsLite from '../../../services/firestore/gdeTransactionsLite'
import * as constants from 'irmlib/common/constants'
import PropTypes from 'prop-types'
import { getUserType, getJobStatusToBeupdated, successToast, errorToast } from '../../../common/functions'
import {
  filterRowsBySelection,
  validateQcGridField,
  collectValidationErrorsForApprove,
  buildValidationErrorsBatched,
} from './qcValidationHelpers'
import { getUser } from '../../../redux/global'
import QcDataGridBulkUpdateTable from '../../Controls/QcDataGridBulkUpdateTable'
import * as routePaths from '../../../navigation/routePaths'
import { useTranslation } from 'react-i18next'

const defaultSelectOption = { value: constants.defaultSelect, label: constants.defaultSelect }
const SKP_BOX_ID = 'skpBoxId'
const CUSTOMER_ID = 'customerId'

const DATA_ENTRY_USER = 0
const DESCRIPTION = 1
const VERIFICATION_USER = 2

const VerticalDivider = () => <YDivider height="15px" />

const BottomPaddedButton = (props) => (
  <>
    <ThemeButton {...props} />
    <VerticalDivider />
  </>
)

const Buttons = props =>
  <>
    <OutlinedButton onClick={props.onClickCancel} noTranslate={true}>{props.t('buttons.cancelAndGoBack')}</OutlinedButton>
    <XDivider width='10px' />
    <OutlinedButton disabled={props.disabled} onClick={props.onClickReject} noTranslate={true}>{props.t('buttons.reject')}</OutlinedButton>
    <XDivider width='10px' />
    <ContainedButton disabled={props.disabled} onClick={props.onClickApprove} noTranslate={true}>{props.t('buttons.saveAndApprove')}</ContainedButton>
    <XDivider width='10px' />
    <BottomPaddedButton id={'dataEntry_button_select_fieldstoupdate'} variant='contained' color='primary' onClick={() => { props.handleUpdateSequenceModal() }} disabled={!props.enableUpdateSequenceBtn} noTranslate={true}>
      {props.t('buttons.updateFileSequenceBtn')}
    </BottomPaddedButton>
  </>

Buttons.propTypes = {
  onClickApprove: PropTypes.func,
  onClickReject: PropTypes.func,
  onClickCancel: PropTypes.func,
  handleUpdateSequenceModal: PropTypes.func,
  enableUpdateSequenceBtn: PropTypes.bool,
  disabled: PropTypes.bool,
  t: PropTypes.any
}

const ButtonsForApprove = props =>
  <>
    <CancelButton onClick={closeGeneralDialog} noTranslate={true} label={props.t('buttons.cancel')}/>
    <XDivider width='10px' />
    <ContainedButton onClick={props.postService} noTranslate={true}>{props.t('buttons.approve')}</ContainedButton>
  </>

ButtonsForApprove.propTypes = {
  postService: PropTypes.func,
  t: PropTypes.any
}

const ButtonsForCancel = props =>
  <>
    <OutlinedButton onClick={props.goBack} noTranslate={true}>{props.t('buttons.no')}</OutlinedButton>
    <XDivider width='10px' />
    <ContainedButton onClick={props.postService} noTranslate={true}>{props.t('buttons.yes')}</ContainedButton>
  </>

ButtonsForCancel.propTypes = {
  postService: PropTypes.func,
  goBack: PropTypes.func,
  t: PropTypes.any
}

const initialState = {
  showTable: false,
  boxDoc: [],
  job: [],
  files: [],
  templateName: '',
  fields: [],
  dataEntryUser: '',
  verificationUser: '',
  columns: [],
  fieldValues: [],
  users: [defaultSelectOption],
  verifyUser: [],
  entryUser: [],
  isVerifyRequired: false,
  assignedUsers: {},
  workerList: [],
  updateFileSequence: [],
  enableUpdateSequenceBtn: false,
  regexFormat: '',
  filesLoading: false,
  selectedFiles: [],
}

const getFileRowId = (row) => String(row?.fileId ?? '')

let loggedInUserDistrict
let loggedInUser
const getService = async (setState) => {
  const getObject = {
  }
  return Promise.resolve(getObject)
}
let user
const FilesForQualityCheck = (props) => {
  const { t } = useTranslation()
  const refLocalBusyCursor = useRef(null)
  const [state, setState, getState] = useMergeState(initialState)
  const buttonRef = useRef()
 
  const formTemplate = [
    {
      label: t('tableColumns.dataEntryUser'),
      fieldKey: 'newDataEntryUser',
      isRequired: true,
      defaultValue: getState().dataEntryUser
    },
    {
      label: t('dataEntry.Description'),
      fieldKey: 'description',
      isRequired: true,
      maxLength: 30
    }
  ]
  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })
  
  const history = useHistory()
  const location = useLocation()
  const BoxId = location.pathname.split('/')[3]
  const JobId = location.pathname.split('/')[2]
  const tableRef = useRef(null)
  const validationCancelRef = useRef(null)
  // AI code start — upfront cell validation state
  const [validationErrors, setValidationErrors] = useState({})
  const [isGridRowEditing, setIsGridRowEditing] = useState(false)
  const [filesLoading, setFilesLoading] = useState(true)

  const refreshValidationErrors = useCallback((rows) => {
    const { files, fields, jobDetails, regexFormat } = getState()
    const gridRows = rows || tableRef.current?.getRows?.() || files
    if (!gridRows?.length || !fields?.length) {
      setValidationErrors({})
      return
    }

    validationCancelRef.current?.()
    validationCancelRef.current = buildValidationErrorsBatched({
      rowList: gridRows,
      fields,
      jobId: JobId,
      jobDetails,
      regexFormat,
      onProgress: setValidationErrors,
      onComplete: setValidationErrors,
      getRowId: getFileRowId,
    })
  }, [getState, JobId])

  const handleGridValidationChange = useCallback((_errors, isRowEditing) => {
    setIsGridRowEditing(isRowEditing)
    if (!isRowEditing) {
      refreshValidationErrors()
    }
  }, [refreshValidationErrors])

  const handleRowsUpdated = useCallback((rows) => {
    refreshValidationErrors(rows)
  }, [refreshValidationErrors])

  useEffect(() => () => {
    validationCancelRef.current?.()
  }, [])
  // AI code end

  const onSelectionChange = useCallback((rows) => {
    setState({ selectedFiles: rows })
  }, [setState])

  useEffect(() => {
    user = getUser()
    loggedInUserDistrict = user.district
    loggedInUser = user.workerId
    getJobData()
  }, [])

  const defaultFileColumn = {
    title: 'Seq.',
    field: 'Sr_No',
    headerAlign: 'center',
    sortable: false,
    editable: 'never',
  }

  const changeSeqFileColumn = {
    title: 'Update Seq.',
    field: 'fileSequence',
    headerAlign: 'center',
    sortable: false,
    editable: 'never',
    render: (rowdata) => {
      const { updateFileSequence } = getState()
      let sequenceNo = ''
      if (rowdata.Sr_No !== updateFileSequence[rowdata.fileId]?.sequenceNo) {
        sequenceNo = updateFileSequence[rowdata.fileId]?.sequenceNo
      }

      const fieldName = 'fileSequence'
      const arrRef = createRef()
      const formTemplate = {
        fieldKey: '',
        defaultValue: sequenceNo,
      }
      return (<TextFieldBorderless ref={arrRef} fieldTemplate={formTemplate} onChange={(e) => handleChangeSequence(rowdata, fieldName, e, arrRef)} />)
    }
  }

  const ButtonsForReject = props =>
    <>
      <CancelButton onClick={closeGeneralDialog} noTranslate={true} label={props.t('buttons.cancel')}/>
      <XDivider width='10px' />
      <SaveButton formTemplate={formTemplate} arrRefs={arrRefs} postService={props.onClickReject} noTranslate={true} saveLabel={props.t('buttons.reject')} />
    </>

  ButtonsForReject.propTypes = {
    onClickReject: PropTypes.func,
    t: PropTypes.any
  }

  const ContentForReject = props => {
    if (getState().isVerifyRequired) {
      arrRefs.push(createRef())
      formTemplate.push(
        {
          label: t('tableColumns.verificationUser'),
          fieldKey: 'newVerificationUser',
          isRequired: true,
          defaultValue: getState().verificationUser
        }
      )
    }

    return (
      <>
        <Label noTranslate={true}>{t('qualityCheck.rejectMsg')}</Label>
        <VerticalDivider />
        <Select noTranslateItems
          data={data}
          fieldTemplate={formTemplate[DATA_ENTRY_USER]}
          items={state.entryUser}
          ref={arrRefs[DATA_ENTRY_USER]}
          noTranslate={true}
        />
        <VerticalDivider />
        { state.isVerifyRequired
          ? <>
            <Select noTranslateItems
              data={data}
              fieldTemplate={formTemplate[VERIFICATION_USER]}
              items={state.verifyUser}
              ref={arrRefs[VERIFICATION_USER]}
              noTranslate={true}
            />
            <VerticalDivider />
          </>
          : null
        }
        <TextField
          data={data}
          fieldTemplate={formTemplate[DESCRIPTION]}
          ref={arrRefs[DESCRIPTION]}
          noTranslate={true}
        />
      </>
    )
  }

  const openApproveModal = () => {
    if (filesLoading) {
      return
    }

    if (isGridRowEditing) {
      errorToast({ message: t('toast.error') })
      return
    }

    const { files, fields, jobDetails, regexFormat, selectedFiles } = getState()
    const gridRows = tableRef.current?.getRows?.() || files
    const rowsToValidate = filterRowsBySelection(gridRows, selectedFiles, getFileRowId)
    const allErrors = collectValidationErrorsForApprove({
      rowsToValidate,
      allRows: gridRows,
      fields,
      jobId: JobId,
      jobDetails,
      regexFormat,
      getRowId: getFileRowId,
    })
    setValidationErrors(allErrors)

    if (Object.keys(allErrors).length > 0) {
      errorToast({ message: t('forms.formValidationError') })
      return
    }

    openGeneralDialog({
      title: t('qualityCheck.approveTransmit'),
      message: t('qualityCheck.approveMsg'),
      buttons: <ButtonsForApprove postService={postService} t={t} />,
      translateMessage: false,
      noTranslateTitle: true,
      closeX: true
    })
  }

  const openRejectModal = () => {
    if (filesLoading) {
      return
    }

    if (isGridRowEditing) {
      errorToast({ message: t('toast.error') })
      return
    }

    const { files, fields, jobDetails, regexFormat } = getState()
    const gridRows = tableRef.current?.getRows?.() || files
    const allErrors = collectValidationErrorsForApprove({
      rowsToValidate: gridRows,
      allRows: gridRows,
      fields,
      jobId: JobId,
      jobDetails,
      regexFormat,
      getRowId: getFileRowId,
    })
    setValidationErrors(allErrors)

    if (Object.keys(allErrors).length > 0) {
      errorToast({ message: t('forms.formValidationError') })
      return
    }

    openGeneralDialog({
      title: t('qualityCheck.rejectModalTitle'),
      message: <ContentForReject/>,
      buttons: <ButtonsForReject onClickReject={onClickReject} t={t}/>,
      translateMessage: false,
      noTranslateTitle: true,
      buttonsPlacement: 'center',
      closeX: true
    })
  }

  const openCancelModal = () => {
    openGeneralDialog({
      title: t('qualityCheck.cancelQC'),
      message: t('qualityCheck.cancelMsg'),
      buttons: <ButtonsForCancel postService={saveOnCancel} goBack={goBack} t={t}/>,
      translateMessage: false,
      noTranslateTitle: true,
      closeX: true
    })
  }

  const goBack = () => {
    // history.goBack()
    history.push(`${routePaths.boxQualityCheck}/${JobId}`)
    closeGeneralDialog()
  }

  const onCancel = () => {
    closeGeneralDialog()
  }

  const handleUpdateSequenceModal = () => {
    const boxId = location.pathname.split('/')[3]
    const jobId = location.pathname.split('/')[2]
    openGeneralDialog({
      title: <FlexByRowCentered><Label noTranslate={true}>{t('dataEntry.updateFileSequence')}</Label></FlexByRowCentered>,
      message: t('dataEntry.changeFileSeq'),
      buttons: 
  <>
    <CancelButton onClick={ onCancel } noTranslate={true} label={t('buttons.cancel')}/>
    <XDivider width='10px' />
    <ContainedButton onClick={ () => handleUpdateSequence(jobId, boxId) } noTranslate={true}>{t('buttons.yes')}</ContainedButton>
  </>,
      closeX: true
    })
  }
  
  const handleUpdateSequence = async (jobId, boxId) => {
    setBusy()
    const filesForBox = await gdeTransactions.getFilesForBox(jobId, boxId)
    const filesListFromGde = filesForBox.docs.sort(function (a, b) {
      return a.id.localeCompare(b.id, undefined, {
        numeric: true,
        sensitivity: 'base'
      })
    })

    const { updateFileSequence } = getState()
    const updatedSequenceArray = []
    let index = 0
    for (const [key, value] of Object.entries(updateFileSequence)) {
      const updatedSequenceData = []
      const { Sr_No: oldSequenceNo, fileId, sequenceNo, sequenceType } = value
      updatedSequenceData.key = key
      updatedSequenceData.oldSequenceNo = oldSequenceNo
      updatedSequenceData.fileId = fileId
      updatedSequenceData.sequenceNo = sequenceNo
      updatedSequenceData.sequenceType = sequenceType
      updatedSequenceArray[index++] = updatedSequenceData
    }

    // below for loop is written to separate exisitng sequence files & new sequence files
    const newSequencesFiles = []
    const newSequencesFileIds = []
    let newSequenceIndex = 0
    
    for (let counter = 1; counter <= filesListFromGde.length; counter++) {
      // this looping is for new files sequence
      updatedSequenceArray.forEach((row, index) => {
        if (row.sequenceType === 'new_sequence' && counter === row.sequenceNo) {
          newSequencesFiles[newSequenceIndex++] = row
          newSequencesFileIds[row.fileId] = row
        }
      })
    }

    let oldSequenceIndex = 0
    const oldSequencesFiles = []
    filesListFromGde.forEach(async(doc, index) => {
      const docData = doc.data()
      const oldDataFileId = docData.fileInfo.fileId || docData.fileNumber
      if (!newSequencesFileIds[oldDataFileId]) {
        const updatedSequenceData = []
        updatedSequenceData.oldSequenceNo = parseInt(oldDataFileId)
        updatedSequenceData.fileId = oldDataFileId
        updatedSequenceData.sequenceNo = parseInt(oldDataFileId)
        updatedSequenceData.sequenceType = 'existing_sequence'
        oldSequencesFiles[oldSequenceIndex++] = updatedSequenceData
      }
    })

    // this for loop is written to push new sequence files in the list of old sequence files as per sequence no. provided
    newSequencesFiles.forEach((row, index) => {
      oldSequencesFiles.splice(--row.sequenceNo, 0, row)
    })

    oldSequencesFiles.forEach(async (doc) => {
      await gdeTransactions.deleteFile(jobId, boxId, doc.fileId)
    })

    const newFileList = []
    const newFileList2 = []
    const myPromise = new Promise(function(resolve, reject) {
      setTimeout(
        filesListFromGde.forEach(async(doc, index) => {
          const docData = doc.data()
          oldSequencesFiles.forEach(async (document, documentIndex) => {
            if (document.fileId === docData.fileInfo.fileId && !newFileList[index]) {
              const newLocationOfFile = documentIndex + 1
              const newFileName = newLocationOfFile.toString().padStart(5, '0')
              docData.fileInfo.fileId = newFileName
              docData.fileNumber = newFileName
              delete docData.fileInfo.sequenceNo
              delete docData.fileInfo.sequenceType
              newFileList[index] = docData.fileInfo
              newFileList2[documentIndex] = docData.fileInfo
              await gdeTransactions.createFile(jobId, boxId, newFileName, docData)
            }
          })
        })
        , 5000)
      resolve(newFileList2)
    })

    myPromise.then(function(newFileList2) {
      setTimeout(successToast({ message: t('toast.filesSeqUpdSuccess') }), 50000)
      setTimeout(closeGeneralDialog(), 50000)
      setTimeout(clearBusy(), 500000)
      setTimeout(history.push(`${routePaths.boxQualityCheck}/${JobId}`), 800000)
    })
  }
  
  const handleChangeSequence = async (rowdata, field, value, arrRef) => {
    rowdata.sequenceType = 'existing_sequence'
    rowdata.sequenceNo = parseInt(rowdata.fileId)
    if (isNaN(value) || value > getState().files.length || value < 0) {
      arrRef.current.setValue('')
      rowdata.sequenceType = 'existing_sequence'
      rowdata.sequenceNo = parseInt(rowdata.fileId)
    } else if (value && rowdata.Sr_No !== value) {
      rowdata.sequenceType = 'new_sequence'
      rowdata.sequenceNo = parseInt(value)
    }
    setState({
      enableUpdateSequenceBtn: false,
      updateFileSequence: { ...getState().updateFileSequence, [rowdata.fileId]: rowdata },
    })
    
    for (const [key, value] of Object.entries(getState().updateFileSequence)) {
      const { sequenceType } = value
      if (sequenceType === 'new_sequence' && key) {
        setState({
          enableUpdateSequenceBtn: true,
        })
      }
    }
  }

  const onClickReject = async (postObject) => {
    closeGeneralDialog()
    const { assignedUsers, workerList, isVerifyRequired } = getState()
    let reKeyData
    const { newDataEntryUser: entryUser, newVerificationUser: verifyUser = '' } = postObject

    if (entryUser in assignedUsers) {
      assignedUsers[entryUser].verifyUser = isVerifyRequired ? verifyUser : ''
      if (!assignedUsers[entryUser].jobCategory.includes('Data Entry User')) {
        assignedUsers[entryUser].jobCategory.push('Data Entry User')
      }
    } else {
      assignedUsers[entryUser] = {
        completedBoxes: 0,
        jobCategory: ['Data Entry User'],
        verifyUser: isVerifyRequired ? verifyUser : '',
        workerName: `${workerList[entryUser].firstName} ${workerList[entryUser].lastName}`
      }
    }

    if (isVerifyRequired) {
      if (verifyUser in assignedUsers) {
        if (!assignedUsers[entryUser].jobCategory.includes('Verification User')) {
          assignedUsers[entryUser].jobCategory.push('Verification User')
        }
      } else {
        assignedUsers[verifyUser] = {
          completedBoxes: 0,
          jobCategory: ['Verification User'],
          verifyUser: '',
          workerName: `${workerList[verifyUser].firstName} ${workerList[verifyUser].lastName}`
        }
      } 
    }

    if (getState().isVerifyRequired) {
      reKeyData = {
        dataEntryUser: entryUser,
        verificationUser: verifyUser,
        status: constants.boxStatus.requiresReKey
      }
    } else {
      reKeyData = {
        dataEntryUser: entryUser,
        status: constants.boxStatus.requiresReKey
      }
    }

    const assignUserList = Object.keys(assignedUsers)

    const jobData = {
      assignedUsers: assignedUsers,
      assignedUserList: assignUserList
    }

    const jobBoxMetricsData = await gdeTransactions.getMetricsForJobBox(JobId, BoxId)
    jobBoxMetricsData.forEach((doc) => {
      const data = doc.data()
      const { metricsFileId, totalBoxCount } = data
      if (metricsFileId !== undefined) {
        const metricsData = {
          totalRecordCount: 0,
          totalBoxCount: 0,
          updatedTs: new Date(),
        }
        totalBoxCount > 0 && gdeTransactions.updateMetricsForJobBox(doc.id, metricsData)
      }
    })

    await gdeTransactions.updateJob(JobId, jobData)
    await gdeTransactionsLite.updateBoxData(JobId, BoxId, reKeyData)
    // history.goBack()
    history.push(`${routePaths.boxQualityCheck}/${JobId}`) 
  }

  const postService = async (postObject) => {
    const jobDetails = await gdeTransactions.getJobById(JobId)
    closeGeneralDialog()
    setBusy()
    const fieldArray = []
    const arrPost = tableRef.current?.getRows?.() || tableRef.current?.dataManager?.data || []
    let costomOrder = 1
    arrPost.forEach(r => {
      delete r.rowSelected
      delete r.tableData
      delete r.__bulkUpdateRowId
      const fieldName = r.fileId
      delete r.Sr_No
      r.customOrder = costomOrder
      costomOrder++
      fieldArray[fieldName] = r
    })
    
    Object.keys(fieldArray).forEach(key => {
      Object.keys(fieldArray[key]).forEach(key1 => {
        const singleFileData = fieldArray[key]
        if (singleFileData[`${key1}_verify`] !== undefined) {
          fieldArray[key][`${key1}_verify`] = singleFileData[key1]
        }
      })
    })

    await gdeTransactionsLite.updateFilesForBox(JobId, BoxId, fieldArray)
    await gdeTransactionsLite.updateBoxStatus(JobId, BoxId, constants.boxStatus.approved, false, []).then(async () => { 
      await statusUpdateForJob(jobDetails.data())
    })
    clearBusy()
    // history.goBack()
    history.push(`${routePaths.boxQualityCheck}/${JobId}`) 
    return Promise.resolve()
  }

  const statusUpdateForJob = async (jobDetail) => {
    const collection = await gdeTransactionsLite.getBoxesForJob(JobId)
    const boxList = []
    const boxUserList = []

    collection.forEach((doc) => {
      const data = doc.data()
      boxList.push({
        boxId: data.boxId,
        entryUser: data.dataEntryUser,
        status: data.status,
        dataEntryUser: data.dataEntryUser,
        verificationUser: data.verificationUser
      })
      boxUserList.push(doc.data().dataEntryUser)
    })
    const checkReadyToTransmit = (Boxes) => {
      if (Boxes.status === constants.boxStatus.approved) {
        return Boxes.status === constants.boxStatus.approved 
      }
      if (Boxes.status === constants.boxStatus.transmitted) {
        return Boxes.status === constants.boxStatus.transmitted 
      }
      if (Boxes.status === constants.boxStatus.exception) {
        return Boxes.status === constants.boxStatus.exception
      }
    }

    const result = boxList.filter(checkReadyToTransmit)



    const transmitBoxEqual = boxList.length === 0 ? false : boxList.length === result.length

    if (transmitBoxEqual && jobDetail.totalBoxes !== 9999) {
      const data = {
        jobStatus: constants.jobStatus.readyToTransmit,
        autoTransmitAndStatus: `${jobDetail.autoTransmit}-${constants.jobStatus.readyToTransmit}`,
      }
      await gdeTransactions.updateJob(JobId, data)
    }
  }

  const saveOnCancel = async () => {
    const { files, fields, jobDetails, regexFormat } = getState()
    const gridRows = tableRef.current?.getRows?.() || files
    const allErrors = collectValidationErrorsForApprove({
      rowsToValidate: gridRows,
      allRows: gridRows,
      fields,
      jobId: JobId,
      jobDetails,
      regexFormat,
      getRowId: getFileRowId,
    })

    if (Object.keys(allErrors).length === 0) {
      closeGeneralDialog()
      const fieldArray = []
      const arrPost = tableRef.current?.getRows?.() || tableRef.current?.dataManager?.data || []
      let costomOrder = 1
      arrPost.forEach(r => {
        delete r.rowSelected
        delete r.tableData
        delete r.__bulkUpdateRowId
        const fieldName = r.fileId
        delete r.Sr_No
        r.customOrder = costomOrder
        costomOrder++
        fieldArray[fieldName] = r
      })

      Object.keys(fieldArray).forEach(key => {
        Object.keys(fieldArray[key]).forEach(key1 => {
          const singleFileData = fieldArray[key]
          if (singleFileData[`${key1}_verify`] !== undefined) {
            fieldArray[key][`${key1}_verify`] = singleFileData[key1]
          }
        })
      })

      // gdeTransactions.updateFilesForBox(JobId, BoxId, fieldArray).then(() => { history.goBack() })
      gdeTransactionsLite.updateFilesForBox(JobId, BoxId, fieldArray).then(() => { 
        history.push(`${routePaths.boxQualityCheck}/${JobId}`) 
      })
   
      return Promise.resolve()
    } else {
      closeGeneralDialog()
    }
  }
  
  const getJobData = async () => {
    // const workerCollection = await gdeTransactions.getWorkersWithDistrict(loggedInUserDistrict)
    const workerCollection = await gdeTransactions.getworkersLists(loggedInUserDistrict)
    const workerDropList = [defaultSelectOption]
    const workerList = []
    workerCollection.forEach((doc) => {
      workerDropList.push({
        value: doc.id,
        label: `${doc.id}-${doc.data().firstName} ${doc.data().lastName}`
      })
      workerList[doc.id] = doc.data()
    })
    await getFileData()
    setState({ entryUser: workerDropList, verifyUser: workerDropList, workerList: workerList })
  }

  const getFileData = async () => {
    setFilesLoading(true)
    const collection = await gdeTransactionsLite.getFilesForBox(JobId, BoxId)
    const documentJob = await gdeTransactions.getJobById(JobId)
    const jobDoc = documentJob.data()
    const [, , , , skpEncoding] = await gdeTransactions.getGdeConfig()
    const regexFormat = skpEncoding[jobDoc?.countryCode]?.regex
    // let templateName
    // if (jobDoc.templateName !== '' && jobDoc.templateName !== undefined) {
    //   templateName = jobDoc.templateName
    // } else {
    //   templateName = jobDoc.standardTemplateName
    // }
    const box = await gdeTransactions.getBox(JobId, BoxId)
    const boxData = box.data()
    // const fileKeyProps = await gdeTransactions.getTemplateFields(templateName)
    const fileKeyProps = jobDoc.templateData
    const fileList = []
    const columnList = [defaultFileColumn]
    columnList.push(changeSeqFileColumn)
    let count = 1
    const verificationUser = collection.docs[0]?.data().verificationUser
    const dataEntryUser = collection.docs[0]?.data().dataEntryUser
    // let fieldKeyList = fileKeyProps.data().templateFields
    let fieldKeyList = fileKeyProps.templateFields
    const assignedUsers = jobDoc.assignedUsers
    const jobUserData = assignedUsers[loggedInUser]
    let isVerifyRequired = false

    fieldKeyList = Object.keys(fieldKeyList).map((key) => {
      const data = fieldKeyList[key]
      data.name = key
      return data
    })

    fieldKeyList.sort((a, b) => (a.customOrder > b.customOrder) ? 1 : ((b.customOrder > a.customOrder) ? -1 : 0))
    // setState({ verificationUser: verificationUser, dataEntryUser: dataEntryUser, templateFields: fieldKeyList, assignedUsers: assignedUsers })
   
    fieldKeyList.forEach((element) => {
      if (element.isSelected && element.name !== SKP_BOX_ID && element.name !== CUSTOMER_ID) {
        columnList.push({
          title: element.customName ? element.customName : element.name,
          field: element.name,
          headerAlign: 'center',
          editable: 'always',
          doNotDuplicate: element.doNotDuplicate,
          validate: (rowData) => validateQcGridField({
            element,
            rowData,
            fieldKeyList,
            jobId: JobId,
            contextRows: getState()?.files,
            jobDetails: getState()?.jobDetails,
            regexFormat,
            translateFn: t,
          }),
        })
        if (element.verify) {
          isVerifyRequired = true
        }
      }
    })
    

    collection.forEach((doc) => {
      const fileInfo = doc.data().fileInfo
      const obj = {
        Sr_No: count,
        fileId: doc.id,
        skpBoxId: BoxId,
        status: doc.data().status,
        ...fileInfo,
      }
      fileList.push(obj)
      count++
    })

    const userType = getUserType(jobUserData, loggedInUser, boxData)
    const statusTobeUpdated = getJobStatusToBeupdated(JobId, userType, isVerifyRequired, user)

    setState({
      files: fileList,
      fields: fieldKeyList,
      columns: columnList,
      isVerifyRequired: isVerifyRequired,
      verificationUser: verificationUser,
      dataEntryUser: dataEntryUser,
      templateFields: fieldKeyList,
      assignedUsers: assignedUsers,
      jobDetails: jobDoc,
      statusTobeUpdated: statusTobeUpdated,
      regexFormat: regexFormat,
      showTable: true,
    })
    setFilesLoading(false)
    validationCancelRef.current?.()
    validationCancelRef.current = buildValidationErrorsBatched({
      rowList: fileList,
      fields: fieldKeyList,
      jobId: JobId,
      jobDetails: jobDoc,
      regexFormat,
      onProgress: setValidationErrors,
      onComplete: setValidationErrors,
      getRowId: getFileRowId,
    })

    return fileList
  }

  const onCloseTable = () => {
    // history.goBack()
    history.push(`${routePaths.boxQualityCheck}/${JobId}`) 
  }

  return (
    <MainRouteSubRoutePage
      mainTitle='routeTitles.dataEntry'
      subTitle='routeTitles.fileQualityCheck'
      buttons={
        <Buttons
          onClickApprove={openApproveModal}
          onClickReject={openRejectModal}
          onClickCancel={openCancelModal}
          handleUpdateSequenceModal={handleUpdateSequenceModal}
          enableUpdateSequenceBtn={getState().enableUpdateSequenceBtn}
          disabled={filesLoading || isGridRowEditing}
          t={t}
        />
      }
    >
      {/* AI code — compact spacing for QC pages */}
      <SummaryHeader jobId= {JobId} boxId= {BoxId} dataKeyed= {state.files.length} templateType = {true} compact />
      {state.showTable && (
        <QcDataGridBulkUpdateTable
          statusTobeUpdated={state.statusTobeUpdated}
          onCloseTable={onCloseTable}
          fileList={state.files}
          columnsList={state.columns}
          filesLoading={filesLoading}
          tableRef={tableRef}
          arrRefs={arrRefs}
          buttonRef={buttonRef}
          boxId={BoxId}
          acc2={state.jobDetails?.accountLevel2}
          acc3={state.jobDetails?.accountLevel3}
          jobId={JobId}
          dataEntryType={getState()?.jobDetails?.dataEntryType}
          jobStatus={getState()?.jobDetails?.jobStatus}
          isFromQC={true}
          qualityCheck={false}
          editTable={true}
          localEditOnly={true}
          onValidationChange={handleGridValidationChange}
          onSelectionChange={onSelectionChange}
          cellValidationErrors={validationErrors} // AI code
          onRowsUpdated={handleRowsUpdated} // AI code
        />
      )}
    </MainRouteSubRoutePage>
  )
}

export default FilesForQualityCheck